import {
  CommunityPageType,
  ICommunityPage,
  IDog,
  IProduct,
  IProfile,
  IStory,
  IStoryPage,
  IUserPage,
  OfferSubType,
  StoryType
} from '@jumpstart/core';

interface ElasticsearchHit<Type> {
  _index: string,
  _type: string,
  _id: string,
  _score: number;
  _source: Type;
}

interface ElasticsearchResponse<Type> {
  took: number;
  timed_out: boolean;
  _shards: {
    total: number;
    successful: number;
    skipped: number;
    failed: number
  };
  hits: {
    total: {
      value: number;
      relation: string
    };
    max_score: number;
    hits: ElasticsearchHit<Type>[];
  }
}

export class ElasticsearchService {

  /**
   * @deprecated
   */
  public static async storiesDeprecated(text: string): Promise<IStory[]> {
    const query = {
      query: {
        match: {
          name: {
            query: text,
            operator: 'and',
            fuzziness: 'auto'
          }
        }
      }
    };
    return this.search<IStory>('scout9-stories', query);
  }

  public static async stories(name: string, type: StoryType | null = null, size: number = 20): Promise<IStoryPage[]> {
    const must: any = [{ match: { name: name } }];
    if (type) {
      must.push({ match: { storyType: type } });
    }
    const query = {
      sort: [
        { bones: 'desc' }
      ],
      query: {
        bool: {
          must: must
        }
      },
      size: size
    };
    console.log(query);
    return this.search<IStoryPage>(`scout9-community`, query);
  }

  public static async users(text: string, size: number = 20): Promise<IUserPage[]> {
    const query = {
      'sort': [{ 'bones': 'desc' }],
      'query': {
        'bool': {
          'must': {
            'multi_match': {
              'type': 'most_fields',
              'fields': [
                'userName',
                'name',
                'breedNames'
              ],
              'query': text
            }
          },
          // @TODO fix me
          // 'filter': {
          //   'term': {
          //     'pageType': CommunityPageType.PROFILE
          //   }
          // }
        }
      },
      size: 100
    };
    return this.search<IUserPage>('scout9-community', query)
      .then((results: IUserPage[]) => {
        console.log(results);
        return results.filter((page: IUserPage) => page.pageType === CommunityPageType.PROFILE);
      });
  }

  public static async pages(
    text: string,
    profile: IProfile | null,
    dog: IDog | null,
    size: number = 20
  ): Promise<ICommunityPage[]> {

    const query = {
      'sort': [
        { 'bones': 'desc' }
      ],
      'query': {
        'multi_match': {
          'query': text,
          'fields': [
            'userName',
            'name',
            'breedNames'
          ]
        }
      },
      'size': size
    };
    return this.search<ICommunityPage>(`scout9-community`, query);
  }

  public static async products(type: OfferSubType | undefined, term: string, size: number = 10): Promise<IProduct[]> {
    const must: any = [{ match: { name: term } }, { match: { invalid: false } }];
    if (type) {
      must.push({ match: { types: type } });
    }
    const query: object = {
      query: {
        bool: {
          must: must
        }
      },
      size: size
    };
    return this.search<IProduct>('scout9-product-catalog', query);
  }

  public static async search<Type>(index: string, query: object): Promise<Type[]> {
    const url: string = `${process.env.REACT_APP_ELASTICSEARCH_ENDPOINT}/${index}/_search`;
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(query) // body data type must match "Content-Type" header
    });
    const res: ElasticsearchResponse<Type> = await response.json();
    return res.hits.hits.map((hit: ElasticsearchHit<Type>) => hit._source);
  }

}
